<template>
    <div v-show="show" class="fixed z-10 inset-0 overflow-y-auto" aria-labelledby="dialog-1-title" role="dialog"
        aria-modal="true">
        <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <!-- Background Overlay -->
            <transition enter-class="ease-out duration-300" enter-active-class="opacity-0" enter-to-class="opacity-100"
                leave-class="ease-in duration-200" leave-active-class="opacity-100" leave-to-class="opacity-0">
                <div key="bgmodal" v-show="show" @click="close"
                    class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity z-0" aria-hidden="true"></div>
            </transition>

            <!-- This element is to trick the browser into centering the modal contents. -->
            <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

            <!-- Modal Panel -->
            <transition enter-class="ease-out duration-300"
                enter-active-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enter-to-class="opacity-100 translate-y-0 sm:scale-100" leave-class="ease-in duration-200"
                leave-active-class="opacity-100 translate-y-0 sm:scale-100"
                leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                <div v-show="show"
                    class="relative inline-block align-bottom focus:ring-0 bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transition-all sm:my-8 sm:align-middle sm:max-w-md sm:w-full sm:p-6">
                    <div>
                        <div class="sm:mx-auto sm:w-full sm:max-w-md">
                            <h1 class="text-3xl font-extrabold text-ap-primary">
                                Login
                            </h1>
                            <div class="rounded-md bg-red-50 p-4 mt-2" v-if="error != null">
                                <div class="flex">
                                    <div class="flex-shrink-0">
                                        <!-- Heroicon name: solid/x-circle -->
                                        <svg class="h-5 w-5 text-red-400" xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                            <path fill-rule="evenodd"
                                                d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                                                clip-rule="evenodd" />
                                        </svg>
                                    </div>
                                    <div class="ml-3">
                                        <h3 class="text-sm font-medium text-red-800">
                                            {{ this.error }}
                                        </h3>
                                    </div>
                                </div>
                            </div>
                            <div class="bg-white py-8 px-4">
                                <div class="space-y-6">
                                    <TextInput
                                        v-model="email"
                                        label="Email address"
                                        name="email"
                                        type="email"
                                        autocomplete="email"
                                        :validation="v$.email"
                                    ></TextInput>

                                    <TextInput
                                        v-model="password"
                                        label="Password"
                                        name="password"
                                        type="password"
                                        autocomplete="current-password"
                                        :validation="v$.password"
                                    ></TextInput>

                                    <div class="md:flex md:items-center md:justify-between">
                                        <div class="flex items-center w-full md:w-1/2">
                                            <input id="remember_me" v-model="remember_me" name="remember_me"
                                                type="checkbox"
                                                class="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded">
                                            <label for="remember_me" class="ml-2 block text-sm text-gray-900">
                                                Remember me
                                            </label>
                                        </div>

                                        <div class="text-sm w-full md:w-1/2 mt-3 md:mt-0 text-right">
                                            <a href="/account/forgot-password" class="font-medium text-indigo-600 hover:text-indigo-500">
                                                Forgot your password?
                                            </a>
                                        </div>
                                    </div>

                                    <div>
                                        <button @click="login"
                                            class="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-ap-fs-primary hover:bg-ap-fs-primary-darkened focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                            Sign in
                                        </button>
                                    </div>
                                </div>

                                <div class="mt-6">
                                    <div class="relative">
                                        <div class="absolute inset-0 flex items-center">
                                            <div class="w-full border-t border-gray-300"></div>
                                        </div>
                                        <div class="relative flex justify-center text-sm">
                                            <span class="px-2 bg-white text-gray-500">
                                                Or create an account
                                            </span>
                                        </div>
                                    </div>

                                    <div class="mt-6">

                                        <a href="/account/create"
                                            class="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-ap-primary hover:bg-ap-primary-darkened focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                            Register
                                        </a>

                                        <button class="absolute right-2 top-2" @click="close">
                                            <svg class="w-6 h-6 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </div>

</template>

<script>
import axios from 'axios';
import useVuelidate from '@vuelidate/core';
import { helpers, email, required } from '@vuelidate/validators';
import TextInputWithLabel from '../TextInputWithLabel.vue';

const { withMessage } = helpers;

export default {
    setup() {
        return {
            v$: useVuelidate(),
        };
    },
    data() {
        return {
            email: '',
            password: null,
            remember_me: false,
            error: null,
        };
    },
    validations() {
        return {
            email: {
                required: withMessage('Email address is required', required),
                email: withMessage('Not a valid email address', email),
            },
            password: {
                required: withMessage('Password is required', required),
            },
        };
    },
    props: {
        showMenu: {
            type: Boolean,
        },
    },
    computed: {
        show() {
            return this.showMenu;
        },
    },
    methods: {
        close() {
            if (this.showMenu) { this.$emit('close-login-form'); }
        },
        async login() {
            const result = await this.v$.$validate();

            if (!result) {
                return false;
            }

            this.$grecaptcha.ready(() => {
                this.$grecaptcha.execute(this.$recaptchaKey, { action: 'login' }).then((token) => {
                    axios.post('/api/login', {
                        email: this.email,
                        password: this.password,
                        remember: this.remember_me,
                        recaptcha: token,
                    }).then((response) => {
                        window.location.href = response.data.redirect;
                    }).catch((error) => {
                        this.error = error.response.data;
                    });
                });
            });

            return true;
        },
    },
    components: {
        TextInput: TextInputWithLabel,
    },
};
</script>
